import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ApiCustomFieldFile } from "@/types/custom-field.types.ts";
import { ButtonIcon, FontAwesomeIcon, LinkTo, Stack, Text } from "@skailer-com/uikit";

export function CustomFieldFileItem({
  file,
  onRemove,
}: {
  file: ApiCustomFieldFile;
  onRemove?: () => void;
}) {
  const { renderFileSize } = useFormatter();

  return (
    <Stack
      direction={"horizontal"}
      gap={"sm"}
      justify={"between"}
      items={"center"}
      className={"bg-dark/5 rounded-xs px-2 py-1 overflow-hidden grow-0"}
    >
      <LinkTo
        variant={"secondary"}
        className={"overflow-hidden text-ellipsis whitespace-nowrap text-brand-dark"}
        to={file.url}
        target={"_blank"}
      >
        {file.name}
      </LinkTo>
      <Stack direction={"horizontal"} items={"center"} gap={"sm"} className={"shrink-0"}>
        <Text className={"shrink-0 text-secondary"}>{renderFileSize(file.size)}</Text>
        {onRemove && (
          <ButtonIcon
            onClick={onRemove}
            className={"shrink-0"}
            variant={"plain"}
            size={"sm"}
            icon={<FontAwesomeIcon icon={"fa-light fa-times"} />}
          />
        )}
      </Stack>
    </Stack>
  );
}
